<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="addMechanism"
            >添加机构</el-button
          >
        </div>
        <div class="header-right">
          <div>
            <span>机构模板：</span>
            <el-select
              v-model="mechaismTemplate"
              size="small"
              placeholder="请选择机构模板"
            >
              <el-option
                v-for="item in templateList"
                :key="item.lifePayInstitutionTemplateId"
                :label="item.templateName"
                :value="item.lifePayInstitutionTemplateId"
              >
              </el-option>
            </el-select>
          </div>
          <el-input
            placeholder="请输入机构名称"
            v-model.trim="searchInput"
            class="input-search"
            size="small"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchMechanism"
            ></el-button>
          </el-input>
        </div>
      </div>
      <div class="tab-content">
        <div class="list" v-if="templateList.length && shopList.length">
          <el-table :data="mechanismList" style="width: 100%;">
            <el-table-column label="机构名称">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.institutionName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="机构模板" align="center">
              <template slot-scope="scope">
                <div>
                  {{
                    templateObj[scope.row.lifePayInstitutionTemplateId]
                      .templateName
                  }}-{{ scope.row.lifePayInstitutionTemplateId }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="模板信息" align="center">
              <template slot-scope="scope">
                <el-popover placement="top" width="200" trigger="hover">
                  <div class="popover">
                    <div class="title">模板信息</div>
                    <div class="content">
                      <div>唯一识别号名称：{{ scope.row.accountNoName }}</div>
                      <div>缴费人姓名：{{ scope.row.accountName }}</div>
                      <div>缴费人信息1：{{ scope.row.accountInfoName01 }}</div>
                      <div>缴费人信息2：{{ scope.row.accountInfoName02 }}</div>
                    </div>
                  </div>
                  <div class="template-name" slot="reference">
                    {{ scope.row.accountName }}
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="关联门店" align="center">
              <template slot-scope="scope">
                <div>
                  {{ shopObj[scope.row.shopStoreId] }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="机构备注" align="center">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.institutionRemark }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="审核状态" align="center">
              <template slot-scope="scope">
                <div>
                  <span
                    class="status"
                    :class="{
                      fail: scope.row.insStatus == 20,
                      ing: scope.row.insStatus == 10,
                      suc: scope.row.insStatus == 30,
                    }"
                  >
                    {{ statusObj[scope.row.insStatus] }}
                  </span>
                  <el-button
                    size="small"
                    type="primary"
                    v-if="scope.row.insStatus == 30"
                    @click="showQrcode(scope.row)"
                    plain
                    >查看二维码</el-button
                  >
                  <el-dialog width="500px" :visible.sync="dialogVisible">
                    <el-image
                      style="width: 440px;height: 570px;margin:20px auto;"
                      v-loding="!dialogImageUrl"
                      :src="dialogImageUrl"
                      :lazy="true"
                      alt
                    ></el-image>
                  </el-dialog>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogCreateMechanismVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="dialogClose"
      width="510px"
    >
      <div slot="title" class="dialog-title">
        {{ createMechanismForm.lifePayInstitutionId ? "编辑机构" : "新建机构" }}
      </div>
      <el-form
        :model="createMechanismForm"
        :rules="createMechanismFormRule"
        ref="createMechanismForm"
        label-width="128px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="机构名称" prop="institutionName">
          <el-input
            v-model="createMechanismForm.institutionName"
            placeholder="请填写机构名称"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构模板" prop="lifePayInstitutionTemplateId">
          <el-select
            v-model="createMechanismForm.lifePayInstitutionTemplateId"
            @change="templateChange"
            size="small"
            placeholder="请选择机构模板"
          >
            <el-option
              v-for="item in addTemplatList"
              :key="item.lifePayInstitutionTemplateId"
              :label="item.templateName"
              :value="item.lifePayInstitutionTemplateId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="唯一识别号名称" prop="accountNoName">
          <el-input
            readonly
            v-model="createMechanismForm.accountNoName"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="缴费户名" prop="accountName">
          <el-input
            readonly
            v-model="createMechanismForm.accountName"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="缴费人信息1" prop="accountInfoName01">
          <el-input
            readonly
            v-model="createMechanismForm.accountInfoName01"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="缴费人信息2" prop="accountInfoName02">
          <el-input
            readonly
            v-model="createMechanismForm.accountInfoName02"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="关联门店" prop="shopStoreId">
          <el-select
            v-model="createMechanismForm.shopStoreId"
            size="small"
            placeholder="请选择关联门店"
          >
            <el-option
              v-for="item in shopList"
              :key="item.shopStoreId"
              :label="item.storeName"
              :value="item.shopStoreId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="createMechanismForm.institutionRemark"
            placeholder="请填写备注"
            size="small"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="tips">
        添加机构后无法<span class="em">编辑</span>和<span class="em">删除</span
        >哦～
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="createMechanism"
          :loading="isSubmit"
          >{{
            createMechanismForm.lifePayInstitutionId ? "立即编辑" : "立即创建"
          }}</el-button
        >
        <el-button @click="dialogCreateMechanismVisible = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getLifePayInstitutionList,
  getLifePayInstitutionTemplates,
  getLifePayInstitutionListCount,
  getShopStores,
  getLifePayInstitutionQrCode,
  addLifePayInstitution,
} from "@/api/index.js";
export default {
  data() {
    return {
      mechaismTemplate: "",
      templateList: [],
      addTemplatList: [],
      templateObj: {},
      shopList: [],
      shopObj: {},
      mechanismList: [],
      statusObj: {
        20: "审核失败",
        10: "审核中",
        30: "审核成功",
      },
      selCard: "",
      searchInput: "",
      pageSize: 10,
      pageCount: 0,
      pageNo: 1,
      dialogVisible: false,
      dialogImageUrl: "",
      dialogCreateMechanismVisible: false,
      createMechanismForm: {
        institutionName: "",
        lifePayInstitutionTemplateId: "",
        shopStoreId: "",
        institutionRemark: "",
        accountNoName: "",
        accountName: "",
        accountInfoName01: "",
        accountInfoName02: "",
      },
      createMechanismFormRule: {
        institutionName: [
          {
            required: true,
            message: "请填写机构名称",
            trigger: "blur",
          },
        ],
        lifePayInstitutionTemplateId: [
          {
            required: true,
            message: "请选择机构模板",
            trigger: "blur",
          },
        ],
        shopStoreId: [
          {
            required: true,
            message: "请选择关联门店",
            trigger: "blur",
          },
        ],
      },
      isSubmit: false,
    };
  },
  watch: {
    mechaismTemplate(val) {
      this.getPageData();
    },
    searchInput(val) {
      if (!val.length) {
        this.getPageData();
      }
    },
  },
  mounted() {
    if (this.$route.query.type == "addvip") {
      this.addMechanism();
    }
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.pageNo = 1;
      this.getLifePayInstitutionList();
      this.getLifePayInstitutionListCount();
    },
    getLifePayInstitutionList() {
      getLifePayInstitutionList({
        pageNo: this.pageNo,
        row: this.pageSize,
        lifePayInstitutionTemplateId: this.mechaismTemplate,
        institutionName: String(this.searchInput),
      }).then((res) => {
        if (res.code == 1) {
          this.mechanismList = res.data;
        }
        if (!this.templateList.length) {
          this.getLifePayInstitutionTemplates();
        }
        if (!this.shopList.length) {
          this.getShopStores();
        }
        if (res.code == -1) {
          this.mechanismList = [];
        }
      });
    },
    getLifePayInstitutionListCount() {
      getLifePayInstitutionListCount({
        lifePayInstitutionTemplateId: this.mechaismTemplate,
        institutionName: String(this.searchInput),
      }).then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data;
        }
        if (res.code == -1) {
          this.pageCount = 0;
        }
      });
    },
    getLifePayInstitutionTemplates() {
      getLifePayInstitutionTemplates({
        row: 1000,
        isEnable: 1,
      }).then((res) => {
        if (res.code == 1) {
          let data = JSON.parse(JSON.stringify(res.data));
          this.addTemplatList = res.data;
          data.unshift({
            templateName: "全部",
            lifePayInstitutionTemplateId: "",
          });
          res.data.forEach((val) => {
            this.templateObj[val.lifePayInstitutionTemplateId] = val;
          });
          this.templateList = data;
          this.$forceUpdate();
        }
        if (res.code == -1) {
          this.templateList = [];
        }
      });
    },
    getShopStores() {
      getShopStores({
        row: 1000,
        isEnable: 1,
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val) => {
            this.shopObj[val.shopStoreId] = val.storeName;
          });
          this.shopList = res.data;
          this.$forceUpdate();
        }
        if (res.code == -1) {
          this.shopList = [];
        }
      });
    },
    searchMechanism() {
      if (!this.searchInput.length) {
        this.$notify({
          title: "警告",
          message: "请输入机构名称",
          type: "warning",
        });
        return;
      }
      this.getPageData();
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getLifePayInstitutionList();
    },
    showQrcode(row) {
      console.log(
        getLifePayInstitutionQrCode({
          lifePayInstitutionId: row.lifePayInstitutionId,
        })
      );
      this.dialogImageUrl = getLifePayInstitutionQrCode({
        lifePayInstitutionId: row.lifePayInstitutionId,
      });
      setTimeout(() => {
        this.dialogVisible = true;
      }, 500);
    },
    dialogClose() {
      this.createMechanismForm = {
        institutionName: "",
        lifePayInstitutionTemplateId: "",
        shopStoreId: "",
        institutionRemark: "",
        accountNoName: "",
        accountName: "",
        accountInfoName01: "",
        accountInfoName02: "",
      };
      this.$refs.createMechanismForm.resetFields();
    },
    addMechanism() {
      this.dialogCreateMechanismVisible = true;
    },
    templateChange(val) {
      console.log(val, this.templateObj[val]);
      this.createMechanismForm.accountNoName = this.templateObj[
        val
      ].accountNoName;
      this.createMechanismForm.accountName = this.templateObj[val].accountName;
      this.createMechanismForm.accountInfoName01 = this.templateObj[
        val
      ].accountInfoName01;
      this.createMechanismForm.accountInfoName02 = this.templateObj[
        val
      ].accountInfoName02;
    },
    createMechanism() {
      this.$refs.createMechanismForm.validate((valid) => {
        if (valid) {
          this.isSubmit = true;
          let params = JSON.parse(JSON.stringify(this.createMechanismForm));
          if (!params.lifePayInstitutionId) {
            addLifePayInstitution(params).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: params.lifePayInstitutionId
                    ? "编辑成功"
                    : "创建成功",
                  type: "success",
                  duration: 2000,
                });
                this.getPageData();
                this.dialogCreateMechanismVisible = false;
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
              setTimeout(() => {
                this.isSubmit = false;
              }, 500);
            });
          } else {
            //   getBindWxQrValue(params).then((res) => {
            //     if (res.code == 1) {
            //       this.$notify({
            //         title: "提示",
            //         message: "新增成功",
            //         type: "success",
            //         duration: 2000,
            //       });
            //       this.getPageData();
            //       this.dialogCreateMechanismVisible = false;
            //     } else {
            //       this.$notify({
            //         title: "提示",
            //         message: res.msg,
            //         type: "error",
            //         duration: 2000,
            //       });
            //     }
            //     setTimeout(() => {
            //       this.isSubmit = false;
            //     }, 500);
            //   });
          }
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .upload-xls {
    margin: 0 10px;
  }
  .list {
    width: 100%;
    padding: 0 20px;
    .template-name {
      color: #66b1ff;
      cursor: pointer;
    }
    .status {
      display: inline-block;
      width: 70px;
      margin-right: 5px;
      &.ing {
        color: #ffaa00;
      }
      &.suc {
        color: #7abd54;
      }
      &.fail {
        color: #ff4c4c;
      }
    }
  }
  .tips {
    border: 1px solid #ff9191;
    background-color: #ffe6e6;
    display: block;
    position: relative;
    color: #666;
    font-size: 12px;
    line-height: 30px;
    padding: 8px;
    border-radius: 3px;
    .em {
      color: #3388ff;
    }
  }
}
.popover {
  .title {
    line-height: 30px;
  }
  .content {
    color: #66b1ff;
  }
}
</style>

<style lang="less">
.upload-xls-btn {
  display: inline-block;
  margin: 0 10px;
}
</style>
